var map = {
	"./ocupacao_turnos.svg": "./src/assets/icons/parking/widget/ocupacao_turnos.svg?367e",
	"./ocupacao_vaga_especial.svg": "./src/assets/icons/parking/widget/ocupacao_vaga_especial.svg",
	"./rotatividade_vagas.svg": "./src/assets/icons/parking/widget/rotatividade_vagas.svg",
	"./tempo_media_permanecia.svg": "./src/assets/icons/parking/widget/tempo_media_permanecia.svg",
	"./total_vagas.svg": "./src/assets/icons/parking/widget/total_vagas.svg",
	"./total_vagas_livres.svg": "./src/assets/icons/parking/widget/total_vagas_livres.svg",
	"./total_vagas_ocupadas.svg": "./src/assets/icons/parking/widget/total_vagas_ocupadas.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/parking/widget sync recursive ^\\.\\/.*$";